export interface GetProductImageOptions {
  width?: number
  height?: number
  imageSize?: string
  index?: number
  quality?: number
  stripMetadata?: number
  stripColorProfile?: number
}

export function getResizedProductImage(
  url: string | null | undefined,
  seo: string | null | undefined,
  options: GetProductImageOptions = {},
) {
  if (!url) {
    return ''
  }

  const {
    width = 400,
    height = 400,
    imageSize = 'M standaard',
    index = 1,
    quality = 100,
    stripMetadata = 1,
    stripColorProfile = 1,
  } = options

  const { size, padding, exar } = getImageParams({
    width,
    height,
    imageSize,
    index,
  })

  const paramsArray = [
    size,
    `t:5:ffffff`,
    `q:${quality}`,
    `sm:${stripMetadata}`,
    `scp:${stripColorProfile}`,
    exar,
    `bg:ffffff`,
    padding,
  ].filter(Boolean)

  const parameters = paramsArray.join('/')

  if (!seo) {
    return parameters ? `${url}?${parameters}` : url
  }

  if (url.includes(seo) && url.includes(parameters)) {
    return url
  }

  const slug = stringToSlug(seo)
  const parts = url.split('.')
  const extension = parts.pop()
  const base = parts.join('.')

  return `${base}/${slug}.${extension}?sf&${parameters}`
}
